import React, { useState } from 'react'

const API = process.env.REACT_APP_API_URL || 'https://sunshoos-v2.onrender.com'
const fmt = (n) => `£${Number(n || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`

export default function AnnualAccounts() {
  const [tab, setTab] = useState('pl')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [result, setResult] = useState(null)
  const [saved, setSaved] = useState(false)

  // Company details
  const [clientName, setClientName] = useState('')
  const [companyNo, setCompanyNo] = useState('')
  const [period, setPeriod] = useState('')
  const [periodEnd, setPeriodEnd] = useState('')
  const [director, setDirector] = useState('')
  const [businessDesc, setBusinessDesc] = useState('')

  // P&L import
  const [plJson, setPlJson] = useState('')

  // Manual entry
  const [man, setMan] = useState({
    // P&L
    turnover: '', cost_of_sales: '', gross_profit: '',
    admin_expenses: '', operating_profit: '', interest: '', tax: '',
    // Balance Sheet — Fixed Assets
    tangible_assets: '', intangible_assets: '',
    // Balance Sheet — Current Assets
    debtors: '', cash: '', stock: '',
    // Balance Sheet — Liabilities
    creditors_lt: '', creditors_st: '', loans: '',
    // Equity
    share_capital: '', retained_earnings: '', other_reserves: '',
  })
  const setM = (k, v) => setMan(m => ({ ...m, [k]: v }))

  async function handlePLSubmit() {
    setLoading(true); setError(''); setResult(null); setSaved(false)
    try {
      let plData = {}
      try { plData = JSON.parse(plJson) } catch { throw new Error('Invalid JSON — paste pl_totals from Bank Stmt → P&L') }
      const res = await fetch(`${API}/api/annual-accounts/compute`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          client_name: clientName || 'Client', company_number: companyNo,
          period: period || 'FY2024', period_end: periodEnd,
          director: director || 'Director', business_description: businessDesc,
          source: 'pl_import', pl_totals: plData,
        })
      })
      const data = await res.json()
      if (!res.ok) throw new Error(data.detail || 'Server error')
      setResult(data)
    } catch (e) { setError(e.message) }
    setLoading(false)
  }

  async function handleManualSubmit() {
    setLoading(true); setError(''); setResult(null); setSaved(false)
    try {
      const n = k => parseFloat(man[k]) || 0
      const res = await fetch(`${API}/api/annual-accounts/compute`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          client_name: clientName || 'Client', company_number: companyNo,
          period: period || 'FY2024', period_end: periodEnd,
          director: director || 'Director', business_description: businessDesc,
          source: 'manual',
          pl: {
            turnover: n('turnover'), cost_of_sales: n('cost_of_sales'),
            gross_profit: n('gross_profit'), admin_expenses: n('admin_expenses'),
            operating_profit: n('operating_profit'), interest: n('interest'), tax: n('tax'),
          },
          balance_sheet: {
            tangible_assets: n('tangible_assets'), intangible_assets: n('intangible_assets'),
            debtors: n('debtors'), cash: n('cash'), stock: n('stock'),
            creditors_lt: n('creditors_lt'), creditors_st: n('creditors_st'), loans: n('loans'),
            share_capital: n('share_capital'), retained_earnings: n('retained_earnings'),
            other_reserves: n('other_reserves'),
          }
        })
      })
      const data = await res.json()
      if (!res.ok) throw new Error(data.detail || 'Server error')
      setResult(data)
    } catch (e) { setError(e.message) }
    setLoading(false)
  }

  async function handleExport(type) {
    try {
      const res = await fetch(`${API}/api/annual-accounts/export-${type}`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(result)
      })
      if (!res.ok) throw new Error(`${type} export failed`)
      const blob = await res.blob()
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `AnnualAccounts_${(result.client_name||'Client').replace(/ /g,'_')}_${(result.period||'').replace(/ /g,'_')}.${type === 'excel' ? 'xlsx' : 'pdf'}`
      a.click(); URL.revokeObjectURL(url)
    } catch (e) { setError(`Export error: ${e.message}`) }
  }

  async function handleSave() {
    try {
      const res = await fetch(`${API}/api/annual-accounts/save`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(result)
      })
      if (!res.ok) throw new Error('Save failed')
      setSaved(true)
    } catch (e) { setError('Save error: ' + e.message) }
  }

  const s = {
    page: { padding: '24px', maxWidth: 980, margin: '0 auto', fontFamily: 'Calibri, sans-serif' },
    card: { background: '#0f1923', border: '1px solid rgba(201,151,58,0.15)', borderRadius: 10, padding: 24, marginBottom: 20 },
    row: { display: 'flex', gap: 14, marginBottom: 14, flexWrap: 'wrap' },
    label: { fontSize: 11, color: 'rgba(255,255,255,0.45)', marginBottom: 5, display: 'block', textTransform: 'uppercase', letterSpacing: 0.5 },
    input: { background: '#0B1929', border: '1px solid rgba(201,151,58,0.2)', borderRadius: 6, color: '#fff', padding: '9px 12px', fontSize: 13, outline: 'none', width: '100%', boxSizing: 'border-box' },
    tabBar: { display: 'flex', gap: 2, marginBottom: 20, background: '#0B1929', borderRadius: 8, padding: 4 },
    tab: a => ({ flex: 1, padding: '9px 0', borderRadius: 6, border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 600, background: a ? '#C9973A' : 'transparent', color: a ? '#0B1929' : 'rgba(255,255,255,0.4)', transition: 'all .2s' }),
    btn: (v='primary') => ({ padding: '11px 22px', borderRadius: 7, border: 'none', cursor: 'pointer', fontWeight: 700, fontSize: 13,
      background: v==='primary'?'#C9973A':v==='green'?'#1a4a2e':v==='blue'?'#0f2a4a':'#1a2a4a',
      color: v==='primary'?'#0B1929':v==='green'?'#4ade80':v==='blue'?'#93c5fd':'#C9973A' }),
    sectionTitle: { fontSize: 11, fontWeight: 700, color: 'rgba(201,151,58,0.7)', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 12 },
    lineRow: (bold, highlight) => ({
      display: 'flex', alignItems: 'center', padding: bold ? '10px 16px' : '8px 16px',
      borderRadius: 6, marginBottom: 4,
      background: highlight==='gold'?'rgba(201,151,58,0.1)':highlight==='green'?'rgba(74,222,128,0.08)':bold?'rgba(255,255,255,0.04)':'transparent',
      border: highlight ? `1px solid ${highlight==='gold'?'rgba(201,151,58,0.25)':'rgba(74,222,128,0.2)'}` : 'none',
      borderBottom: !highlight && !bold ? '1px solid rgba(255,255,255,0.05)' : 'none',
    }),
  }

  const pl = result?.pl || {}
  const bs = result?.balance_sheet || {}
  const notes = result?.notes || {}

  return (
    <div style={s.page}>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: '#fff', margin: 0 }}>Annual Accounts</h1>
        <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.35)', margin: '4px 0 0' }}>
          FRS 105 Micro-entity · P&amp;L · Balance Sheet · Notes · Directors' Report · Excel + PDF
        </p>
      </div>

      {/* Company Details */}
      <div style={s.card}>
        <div style={s.sectionTitle}>Company Details</div>
        <div style={s.row}>
          <div style={{ flex: 2, minWidth: 180 }}>
            <label style={s.label}>Company Name</label>
            <input style={s.input} value={clientName} onChange={e => setClientName(e.target.value)} placeholder="e.g. Acme Trading Ltd" />
          </div>
          <div style={{ flex: 1, minWidth: 130 }}>
            <label style={s.label}>Company Number</label>
            <input style={s.input} value={companyNo} onChange={e => setCompanyNo(e.target.value)} placeholder="e.g. 12345678" />
          </div>
          <div style={{ flex: 1, minWidth: 120 }}>
            <label style={s.label}>Period</label>
            <input style={s.input} value={period} onChange={e => setPeriod(e.target.value)} placeholder="e.g. FY2024" />
          </div>
          <div style={{ flex: 1, minWidth: 150 }}>
            <label style={s.label}>Period End Date</label>
            <input style={s.input} type="date" value={periodEnd} onChange={e => setPeriodEnd(e.target.value)} />
          </div>
        </div>
        <div style={s.row}>
          <div style={{ flex: 1, minWidth: 180 }}>
            <label style={s.label}>Director Name</label>
            <input style={s.input} value={director} onChange={e => setDirector(e.target.value)} placeholder="e.g. John Smith" />
          </div>
          <div style={{ flex: 3, minWidth: 260 }}>
            <label style={s.label}>Business Description (for Directors' Report)</label>
            <input style={s.input} value={businessDesc} onChange={e => setBusinessDesc(e.target.value)} placeholder="e.g. Provides IT consultancy services to SMEs across the UK" />
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div style={s.tabBar}>
        <button style={s.tab(tab==='pl')} onClick={() => setTab('pl')}>📊 Import from P&amp;L</button>
        <button style={s.tab(tab==='manual')} onClick={() => setTab('manual')}>✏️ Manual Entry</button>
      </div>

      {/* P&L Import Tab */}
      {tab === 'pl' && (
        <div style={s.card}>
          <div style={s.sectionTitle}>Import P&amp;L Totals</div>
          <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', marginBottom: 14 }}>
            Run Bank Stmt → P&amp;L first, copy the <code style={{ color: '#C9973A' }}>pl_totals</code> JSON and paste below.
            Balance Sheet figures will need to be added in the Manual Entry tab or entered as adjustments after generation.
          </p>
          <label style={s.label}>Paste pl_totals JSON</label>
          <textarea
            style={{ ...s.input, height: 150, resize: 'vertical', fontFamily: 'monospace', fontSize: 12 }}
            value={plJson} onChange={e => setPlJson(e.target.value)}
            placeholder={'{\n  "Sales/Income": 185000,\n  "Purchases": 42000,\n  ...\n}'}
          />
          <div style={{ marginTop: 16 }}>
            <button style={s.btn('primary')} onClick={handlePLSubmit} disabled={loading}>
              {loading ? '⏳ Generating with GPT-4o…' : '▶ Generate Annual Accounts'}
            </button>
          </div>
        </div>
      )}

      {/* Manual Entry Tab */}
      {tab === 'manual' && (
        <div style={s.card}>
          {/* P&L figures */}
          <div style={s.sectionTitle}>Profit &amp; Loss</div>
          <div style={s.row}>
            {[['turnover','Turnover (£)'],['cost_of_sales','Cost of Sales (£)'],['gross_profit','Gross Profit (£)'],
              ['admin_expenses','Admin Expenses (£)'],['operating_profit','Operating Profit (£)'],
              ['interest','Interest (£)'],['tax','Corporation Tax (£)']].map(([k,lbl]) => (
              <div key={k} style={{ flex: 1, minWidth: 160 }}>
                <label style={s.label}>{lbl}</label>
                <input style={s.input} type="number" value={man[k]} onChange={e => setM(k, e.target.value)} placeholder="0.00" />
              </div>
            ))}
          </div>

          {/* Balance Sheet */}
          <div style={{ ...s.sectionTitle, marginTop: 16 }}>Balance Sheet — Fixed Assets</div>
          <div style={s.row}>
            {[['tangible_assets','Tangible Assets (£)'],['intangible_assets','Intangible Assets (£)']].map(([k,lbl]) => (
              <div key={k} style={{ flex: 1, minWidth: 200 }}>
                <label style={s.label}>{lbl}</label>
                <input style={s.input} type="number" value={man[k]} onChange={e => setM(k, e.target.value)} placeholder="0.00" />
              </div>
            ))}
          </div>

          <div style={{ ...s.sectionTitle, marginTop: 8 }}>Balance Sheet — Current Assets</div>
          <div style={s.row}>
            {[['debtors','Debtors (£)'],['cash','Cash &amp; Bank (£)'],['stock','Stock (£)']].map(([k,lbl]) => (
              <div key={k} style={{ flex: 1, minWidth: 180 }}>
                <label style={s.label}>{lbl}</label>
                <input style={s.input} type="number" value={man[k]} onChange={e => setM(k, e.target.value)} placeholder="0.00" />
              </div>
            ))}
          </div>

          <div style={{ ...s.sectionTitle, marginTop: 8 }}>Balance Sheet — Liabilities</div>
          <div style={s.row}>
            {[['creditors_st','Creditors &lt;1yr (£)'],['creditors_lt','Creditors &gt;1yr (£)'],['loans','Loans (£)']].map(([k,lbl]) => (
              <div key={k} style={{ flex: 1, minWidth: 180 }}>
                <label style={s.label} dangerouslySetInnerHTML={{__html: lbl}} />
                <input style={s.input} type="number" value={man[k]} onChange={e => setM(k, e.target.value)} placeholder="0.00" />
              </div>
            ))}
          </div>

          <div style={{ ...s.sectionTitle, marginTop: 8 }}>Equity</div>
          <div style={s.row}>
            {[['share_capital','Share Capital (£)'],['retained_earnings','Retained Earnings (£)'],['other_reserves','Other Reserves (£)']].map(([k,lbl]) => (
              <div key={k} style={{ flex: 1, minWidth: 180 }}>
                <label style={s.label}>{lbl}</label>
                <input style={s.input} type="number" value={man[k]} onChange={e => setM(k, e.target.value)} placeholder="0.00" />
              </div>
            ))}
          </div>

          <div style={{ marginTop: 16 }}>
            <button style={s.btn('primary')} onClick={handleManualSubmit} disabled={loading}>
              {loading ? '⏳ Generating with GPT-4o…' : '▶ Generate Annual Accounts'}
            </button>
          </div>
        </div>
      )}

      {/* Error */}
      {error && (
        <div style={{ background:'rgba(220,38,38,0.08)', border:'1px solid rgba(220,38,38,0.25)', borderRadius:8, padding:'12px 16px', marginBottom:16, color:'#f87171', fontSize:13 }}>
          ⚠ {error}
        </div>
      )}

      {/* Results */}
      {result && (
        <>
          {/* Action bar */}
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16, flexWrap:'wrap', gap:10 }}>
            <div>
              <div style={{ fontSize:17, fontWeight:700, color:'#fff' }}>{result.client_name} — {result.period}</div>
              <div style={{ fontSize:12, color:'rgba(255,255,255,0.35)', marginTop:3 }}>
                Co. {result.company_number || '—'} · Period end: {result.period_end || '—'} · FRS 105 Micro-entity
              </div>
            </div>
            <div style={{ display:'flex', gap:10, flexWrap:'wrap' }}>
              <button style={s.btn('green')} onClick={() => handleExport('excel')}>⬇ Excel</button>
              <button style={s.btn('blue')} onClick={() => handleExport('pdf')}>⬇ PDF</button>
              <button style={s.btn('save')} onClick={handleSave} disabled={saved}>{saved ? '✓ Saved' : '💾 Save'}</button>
            </div>
          </div>

          {/* P&L Statement */}
          <div style={s.card}>
            <div style={s.sectionTitle}>Profit &amp; Loss Statement</div>
            {[
              { label: 'Turnover', key: 'turnover', bold: false },
              { label: 'Cost of Sales', key: 'cost_of_sales', bold: false },
              { label: 'Gross Profit', key: 'gross_profit', bold: true, highlight: 'gold' },
              { label: 'Administrative Expenses', key: 'admin_expenses', bold: false },
              { label: 'Operating Profit / (Loss)', key: 'operating_profit', bold: true },
              { label: 'Interest Payable', key: 'interest', bold: false },
              { label: 'Corporation Tax', key: 'tax', bold: false },
              { label: 'Profit for the Year', key: 'profit_after_tax', bold: true, highlight: 'green' },
            ].map(({ label, key, bold, highlight }) => (
              <div key={key} style={s.lineRow(bold, highlight)}>
                <div style={{ flex: 1, fontSize: bold ? 13 : 12, fontWeight: bold ? 700 : 400, color: bold ? '#fff' : 'rgba(255,255,255,0.6)' }}>{label}</div>
                <div style={{ fontSize: bold ? 14 : 12, fontWeight: bold ? 700 : 400, color: highlight==='green'?'#4ade80':highlight==='gold'?'#C9973A':'#fff' }}>{fmt(pl[key])}</div>
              </div>
            ))}
          </div>

          {/* Balance Sheet */}
          <div style={s.card}>
            <div style={s.sectionTitle}>Balance Sheet</div>

            <div style={{ fontSize: 11, color: '#C9973A', fontWeight: 700, marginBottom: 8, textTransform: 'uppercase', letterSpacing: 0.5 }}>Fixed Assets</div>
            {[['Tangible Assets','tangible_assets'],['Intangible Assets','intangible_assets']].map(([lbl,k]) => (
              <div key={k} style={s.lineRow(false, null)}>
                <div style={{ flex:1, fontSize:12, color:'rgba(255,255,255,0.6)' }}>{lbl}</div>
                <div style={{ fontSize:12, color:'#fff' }}>{fmt(bs[k])}</div>
              </div>
            ))}
            <div style={{ ...s.lineRow(true, null), marginTop: 4 }}>
              <div style={{ flex:1, fontSize:13, fontWeight:700, color:'#fff' }}>Total Fixed Assets</div>
              <div style={{ fontSize:13, fontWeight:700, color:'#C9973A' }}>{fmt(bs.total_fixed_assets)}</div>
            </div>

            <div style={{ fontSize: 11, color: '#C9973A', fontWeight: 700, margin: '16px 0 8px', textTransform: 'uppercase', letterSpacing: 0.5 }}>Current Assets</div>
            {[['Stock','stock'],['Debtors','debtors'],['Cash & Bank','cash']].map(([lbl,k]) => (
              <div key={k} style={s.lineRow(false, null)}>
                <div style={{ flex:1, fontSize:12, color:'rgba(255,255,255,0.6)' }}>{lbl}</div>
                <div style={{ fontSize:12, color:'#fff' }}>{fmt(bs[k])}</div>
              </div>
            ))}
            <div style={{ ...s.lineRow(true, null), marginTop: 4 }}>
              <div style={{ flex:1, fontSize:13, fontWeight:700, color:'#fff' }}>Total Current Assets</div>
              <div style={{ fontSize:13, fontWeight:700, color:'#C9973A' }}>{fmt(bs.total_current_assets)}</div>
            </div>

            <div style={{ fontSize: 11, color: '#C9973A', fontWeight: 700, margin: '16px 0 8px', textTransform: 'uppercase', letterSpacing: 0.5 }}>Creditors: Amounts Falling Due Within One Year</div>
            {[['Creditors (<1yr)','creditors_st'],['Loans','loans']].map(([lbl,k]) => (
              <div key={k} style={s.lineRow(false, null)}>
                <div style={{ flex:1, fontSize:12, color:'rgba(255,255,255,0.6)' }}>{lbl}</div>
                <div style={{ fontSize:12, color:'#f87171' }}>{fmt(bs[k])}</div>
              </div>
            ))}
            <div style={{ ...s.lineRow(true, 'gold'), marginTop: 4 }}>
              <div style={{ flex:1, fontSize:13, fontWeight:700, color:'#fff' }}>Net Assets</div>
              <div style={{ fontSize:14, fontWeight:700, color:'#C9973A' }}>{fmt(bs.net_assets)}</div>
            </div>

            <div style={{ fontSize: 11, color: '#C9973A', fontWeight: 700, margin: '16px 0 8px', textTransform: 'uppercase', letterSpacing: 0.5 }}>Equity</div>
            {[['Share Capital','share_capital'],['Retained Earnings','retained_earnings'],['Other Reserves','other_reserves']].map(([lbl,k]) => (
              <div key={k} style={s.lineRow(false, null)}>
                <div style={{ flex:1, fontSize:12, color:'rgba(255,255,255,0.6)' }}>{lbl}</div>
                <div style={{ fontSize:12, color:'#fff' }}>{fmt(bs[k])}</div>
              </div>
            ))}
            <div style={{ ...s.lineRow(true, 'green'), marginTop: 4 }}>
              <div style={{ flex:1, fontSize:13, fontWeight:700, color:'#fff' }}>Total Equity</div>
              <div style={{ fontSize:14, fontWeight:700, color:'#4ade80' }}>{fmt(bs.total_equity)}</div>
            </div>

            {/* Balance check */}
            <div style={{ marginTop: 12, padding: '10px 14px', borderRadius: 7, background: bs.balanced ? 'rgba(74,222,128,0.07)' : 'rgba(239,68,68,0.07)', border: `1px solid ${bs.balanced ? 'rgba(74,222,128,0.2)' : 'rgba(239,68,68,0.2)'}`, fontSize: 12, color: bs.balanced ? '#4ade80' : '#f87171', fontWeight: 600 }}>
              {bs.balanced ? '✓ Balance Sheet balances (Assets = Liabilities + Equity)' : '⚠ Balance Sheet does not balance — please review figures'}
            </div>
          </div>

          {/* Notes to Accounts */}
          {notes && Object.keys(notes).length > 0 && (
            <div style={s.card}>
              <div style={s.sectionTitle}>Notes to the Accounts</div>
              {Object.entries(notes).map(([k, v]) => (
                <div key={k} style={{ marginBottom: 14 }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: '#C9973A', marginBottom: 5 }}>{k}</div>
                  <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.6)', lineHeight: 1.7 }}>{v}</div>
                </div>
              ))}
            </div>
          )}

          {/* Directors' Report */}
          {result.directors_report && (
            <div style={s.card}>
              <div style={s.sectionTitle}>Directors' Report</div>
              <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)', lineHeight: 1.85, whiteSpace: 'pre-wrap' }}>
                {result.directors_report}
              </div>
              {result.period_end && (
                <div style={{ marginTop: 20, fontSize: 12, color: 'rgba(255,255,255,0.35)' }}>
                  Signed on behalf of the Board of Directors<br />
                  <span style={{ color: '#fff', fontWeight: 600 }}>{result.director}</span><br />
                  Director · {result.period_end}
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  )
}
